import axios from "axios";
import querystring from "querystring"
import { IntercomAPI } from 'react-intercom';
import {getIntercomUser} from '../presentation/shared/getUserIntercom/GetUserIntercom';

const API_CLIENT_ID= 'V64QLUP0V9H9E1rdPTGcP6wvettYiM6cLjzTcFzj';
const API_CLIENT_SECRET= '0x0cwqdcrP9qNsRi9VRErCw1uzd1mrK8LOV3YL7rXWEvcKL5JO6EZsPGcVu8AEH8ni5WpXTnfkYVchST9d9Qn6owwTkxfgMJfyI2mgk5nWaxvFe3XIWMjdMxEY8L2cEU';

class AuthenticationService {

    login(userData) {
        const data = querystring.stringify({
            grant_type: "password",
            username: userData.email,
            password: userData.password
        });

        const auth = { username: API_CLIENT_ID, password: API_CLIENT_SECRET };
        const headers = { "Content-Type": "application/x-www-form-urlencoded" };
        const config = { auth, headers };

        return new Promise(async (resolve, reject) => {
            try {
                let response = await axios.post("o/token/", data, config);

                if (response.status === 200) {
                    this.setTokens(response.data);
                    this.getInfoUser();
                }
                resolve(response);
            } catch (ex){
                this.reportLoginError({
                    grant_type: "password",
                    username: userData.email,
                    password: userData.password
                });
                reject(ex.response.data);
            }
        });
    }

    register(){

    }

    reportLoginError(data){
        return  axios.post("api/login-error/", data);
    }

    preRegister(userData){
        return axios.post("api/preregistration/",
            querystring.stringify(userData), { headers: { "Content-Type": "application/x-www-form-urlencoded" }
        });
    }

    teste(userData){
        axios.post("api/preregistration/",
            querystring.stringify(userData), { headers: { "Content-Type": "application/x-www-form-urlencoded" }
        }).then( (response) => {
            // console.log(response, 123)
        });
    }

    async forgotPassword(userEmail){
        return new Promise(async (resolve, reject) => {
            try {
                let response = await axios.post("api/recovery/", { email: userEmail });
                resolve(response);
            } catch(ex){
                reject(ex);
            }
        })
    }

    setTokens(response) {
        localStorage.setItem("access_token", response.access_token);
        localStorage.setItem("refresh_token", response.refresh_token);
    }

    logout() {
        window.localStorage.clear();
        IntercomAPI('shutdown');
        window.location.href = "/";
    }
    redirectAfterLogin(){
      const params = new URLSearchParams(window.location.search);
      const next = params.get('next', "");
      let params_string = "";
      for(var key of params.keys()) {
          let value = params.get(key)
          if(key !== "next"){
            params_string += `&${key}=${value}`
          }
      }
      if(params_string){
        window.location.href = `${next}?${params_string}`;
      }else if(next){
        window.location.href = `${next}`;
      }else{
        window.location.href = "/"
      }
    }
    async getInfoUser(){
        const headers = { Authorization: `Bearer ${window.localStorage.getItem('access_token')}`};
        const configUser = { headers };

        let response = await axios.get('api/me/', configUser);
        let r = response.data
        let user = {}
        user.first_name     = r.first_name;
        user.last_name      = r.last_name;
        user.id             = r.id;
        user.entity_type    = r.entity_type;
        user.entity_stype    = r.entity_stype;
        user.entity_id      = r.entity_id;
        user.email          = r.email;
        user.welcome_msg    = r.welcome_msg;
        user.buyer_locations= r.buyer_locations;
        user.user_hash      = r.user_hash;
        user.is_staff       = r.is_staff;


        localStorage.setItem("userData", JSON.stringify(user));
        const intercomUser = getIntercomUser()
        IntercomAPI("update", intercomUser);
        IntercomAPI("trackEvent", "log_in");

        localStorage.setItem("id", response.data.id);
        localStorage.setItem("user", response.data.first_name);
        localStorage.setItem("user_type", response.data.entity_type);
        localStorage.setItem("user_stype", response.data.entity_stype);
        localStorage.setItem("seller_slug", response.data.seller_slug);
        localStorage.setItem("email", response.data.email);
        localStorage.setItem("show_welcome_msg", response.data.welcome_msg);
        this.redirectAfterLogin()
    }
}

export default new AuthenticationService();
